<template>
  <ValidationObserver ref="maritalStatus">
    <div>
      <h2 class="mb-5">
        What is your marital status?
      </h2>
    </div>
    <div v-if="isFetchingMaritalStatuses">
      <v-skeleton-loader type="list-item-three-line" />
    </div>
    <ValidationProvider
      v-slot="{ errors }"
      name="maritalStatus"
      rules="required"
      v-else
    >
      <RadioButton
        v-model="maritalStatus"
        @select="val => (maritalStatus = val)"
        :options="options"
        mixed
        :selectedValue="maritalStatus"
        :errorMessages="showValidationErrors ? errors : ''"
      />
    </ValidationProvider>

    <div class="d-flex justify-end">
      <PrimaryButton @click.native="nextStep" :loading="isLoading">
        Continue
      </PrimaryButton>
    </div>
  </ValidationObserver>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { DATA_NAMESPACE } from "@/store/modules/data";
import { createNamespacedHelpers } from "vuex";
import { FETCH_MARITAL_STATUSES } from "@/store/modules/data/actions";
import {
  GET_MARITAL_STATUSES,
  GET_IS_FETCHING_MARITAL_STATUSES
} from "@/store/modules/data/getters";
import { map } from "lodash";
import RadioButton from "@/components/common/RadioButton";
import {
  includePreferNotSayOption,
  getFormattedValue
} from "@/views/profile/QuestionsAndAnswers/steps/Diversity/utils";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const { mapGetters, mapActions } = createNamespacedHelpers(DATA_NAMESPACE);

export default {
  name: "MaritalStatus",
  components: {
    PrimaryButton,
    RadioButton,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    isLoading: Boolean,
    userDiversityTraits: Object
  },
  created() {
    this.fetchMaritalStatuses();
  },
  data() {
    return {
      showValidationErrors: false,
      maritalStatus: this.userDiversityTraits.maritalStatus
    };
  },
  computed: {
    options() {
      const fetchedOptions = map(this.maritalStatuses, ({ name }) => ({
        label: name,
        value: name
      }));
      return includePreferNotSayOption(fetchedOptions);
    },
    ...mapGetters({
      maritalStatuses: GET_MARITAL_STATUSES,
      isFetchingMaritalStatuses: GET_IS_FETCHING_MARITAL_STATUSES
    })
  },
  methods: {
    ...mapActions({
      fetchMaritalStatuses: FETCH_MARITAL_STATUSES
    }),
    async nextStep() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.maritalStatus.validate();
      if (isValid) {
        this.$emit("nextStep", {
          data: { maritalStatus: getFormattedValue(this.maritalStatus) },
          dataType: "divirsityTraits"
        });
      }
    }
  }
};
</script>

<style lang="scss"></style>
